'use client';
import React from 'react';
import styles from './FinanceSegmented.scss';

export default function FinanceSegmented({ items, activeIndex, onClick }) {
  const handleClick = (value) => {
    onClick?.(value);
  };

  return (
    <div className={'toggle'}>
      <div className={'inner'}>
        {items.map((item) => (
          <div
            key={item.index}
            role="presentation"
            className={'item'}
            onClick={() => handleClick(item.index)}
            style={{
              color: item.index === activeIndex ? '#0d0b26' : '#0d0b26',
              zIndex: 9,
            }}
          >
            {item.title}
          </div>
        ))}
        <div
          className={'slicer'}
          style={{
            transform: `translateX(${activeIndex * 100}%)`,
            width: `${98 / items.length}%`,
          }}
        />
      </div>
    </div>
  );
}
